import classnames from 'classnames';
import React from 'react';
import Icon from '../Icon';
import Link from '../Link';
import Text from '../Text';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    alignIcon: {
        display: 'inline-flex',
        verticalAlign: 'middle'
    },
    textPadding: {
        paddingLeft: Tokens.spacingXSmall
    }
});
const IconLink = (props) => {
    const { classes, classNameIcon, className, href, id, label, large, name, type, onLinkClick } = props;
    let classText = classes.textPadding;
    if (className) {
        classText = classnames(classText, className);
    }
    return (React.createElement(Link, { id: id, href: href, onClick: onLinkClick },
        React.createElement("div", { className: classes.alignIcon },
            React.createElement(Icon, { className: classNameIcon, name: name, large: large, type: type })),
        React.createElement(Text, { className: classText, color: "inherit", display: "inline" }, label)));
};
export default withStyles(styles)(IconLink);
